import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Support-listing--------------------------
export const supportListApi = async (data) => {
  const endPoint = `/admin/users/support` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// -------------------------Change Support Status------------
export const changeSupportStatusApi = async (id,data) => {
  const endPoint = `/admin/users/support/${id}`;
  return await axios.patch(endPoint, data, setJwtToken());
};

// // -------------------------Delete SubAdmin ------------
// export const deleteSubAdminApi = async (id, data) => {
//   const endPoint = `/admin/users/support/${id}`;
//   return await axios.patch(endPoint, data, setJwtToken());
// };

